import React, { useEffect, useState, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import CountUp from "react-countup";
import axios from "axios";

import Fundraiser from "./Fundraiser";
import Progress from "./Progress";
import { ErrorMessage, Spinner } from "../elements";

import GCXLogo from "../../images/gcx/circle_logo_w.png";
import GCXLogoLupo from "../../images/gcx/circle_logo_lupo.png";

const GCXOverlay = (props) => {
  const timer = useRef(0);

  const [state, setState] = useState({
    startAmount: 0,
    streamer: "loading",
  });

  const [userRaised, setUseRaised] = useState(0);

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/gcx-overlay/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.gcxStore.socketConnect(streamType, username, slug);

      // timer.current = setInterval(() => receive(), 10000);

      return () => props.gcxStore.socketDisconnect();
    }
    //props.userStore.getAccessToken();
  }, []);

  // const receive = () => {
  //   const URL = process.env.REACT_APP_GCX_SERVICE_URI + "/getGcxMarathon";

  //   axios
  //     .post(URL)
  //     .then((response) => {
  //       // client.nextup = response.data.nextup;
  //       // console.log('next up', client.nextUp)
  //       // console.log(response.data);
  //       setState((prev) => {
  //         return {
  //           ...prev,
  //           streamer: response.data[0].streamer,
  //           startAmount: response.data[0].start_amount,
  //         };
  //       });
  //       // console.log("NextUp back from PG write", response);
  //     })
  //     .catch((err) => console.log("***** write to PG error:", err));
  // };

  const { raised, raisedVal, progress, goalVal, error, isLoading } =
    props.gcxStore;

  // const userRaised = raised - state.startAmount;

  // const userRaised =
  //   raised - state.startAmount < 0 ? 0 : raised - state.startAmount;

  useEffect(() => {
    setUseRaised(
      raised - state.startAmount < 0 ? 0 : raised - state.startAmount
    );
    // console.log("this is the use effect", userRaised);
  }, [state]);

  // console.log("hi");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const size = urlParams.get("size");
  const lupo = urlParams.get("lupo");
  const fundraiser = urlParams.get("fundraiser");

  return error ? (
    <ErrorMessage>THERE IS AN ERROR</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    // <div
    //   className={
    //     "gcx-overlay " +
    //     size +
    //     `${lupo === "yes" ? " lupo" : ""}` +
    //     `${fundraiser !== "yes" ? " normal" : ""}`
    //   }
    // >
    //   <div
    //     className={
    //       "gcx-overlay_left" + `${fundraiser !== "yes" ? " normal" : ""}`
    //     }
    //   >
    //     <div className="gcx-overlay_logo">
    //       {lupo === "yes" ? <img src={GCXLogoLupo} /> : <img src={GCXLogo} />}
    //     </div>
    //     {fundraiser === "yes" ? (
    //       <Fundraiser userRaised={userRaised} username={state.streamer} />
    //     ) : (
    //       ""
    //     )}
    //     <div className="lights">
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //       <div className="light"></div>
    //     </div>
    //   </div>
    //   <div className={"gcx-overlay_right " + size}>
    //     <Progress raised={raised} goal={goalVal} progress={progress} />
    //   </div>
    // </div>
    <div className="gcx-overlay">
      <div className="overlay_wrapper">
        <div className="logo"></div>
        <div className="raised_therm_wrapper">
          <span className="rainbow"></span>
          <div className="total_raised">
            <span className="rainbow"></span>
            <span>$</span>

            <CountUp
              end={raised}
              duration={1}
              separator=","
              decimals={raised - Math.floor(raised) !== 0 ? 2 : 0}
              preserveValue={true}
              useEasing={false}
            />
          </div>
          <div className="progress_bar">
            <span className="rainbow"></span>
            <div
              className="progress_bar_inner"
              style={{
                width: `
              ${progress}%
            `,
              }}
            ></div>
          </div>
        </div>
        {/* <div className="total_raised">
          <span className="rainbow"></span>
          <span>$</span>

          <CountUp
            end={raised}
            duration={1}
            separator=","
            decimals={raised - Math.floor(raised) !== 0 ? 2 : 0}
            preserveValue={true}
            useEasing={false}
          />
        </div>
        <div className="progress_bar">
          <span className="rainbow"></span>
          <div
            className="progress_bar_inner"
            style={{
              width: `
              60%
            `,
            }}
          ></div>
        </div> */}
      </div>
    </div>
  );
};

export default inject("gcxStore")(observer(GCXOverlay));
